import Home from './home';
import HomeDetail from './home-detail';

export {HomeDetail};
export default Home;
